<template>
  <div class="commonReport" @click.stop="fatClick">
    <div style="margin:20px 0;position:relative;">
      <div class="drawer-subtitle_common">
        <span class="drawer-subtitle-text">举报信息</span>
      </div>
      <div style="position:absolute;right:40px;top:-4px">
        <el-link type="primary" :underline="false" @click="changDataInfo(), completeShow = false"
          v-show="completeShow && showChangeInfo">修改信息</el-link>
        <el-button @click="affirmInfo" v-show="!completeShow" size="small" type="primary">确认</el-button>
        <el-button v-show="!completeShow" size="small" @click="cancelInfo">取消</el-button>
      </div>
    </div>
    <!-- <el-row class="info_header">
      <el-col :span="14">
        <div class="drawer-subtitle_common">
          <span class="drawer-subtitle-text">举报信息</span>
        </div>
      </el-col>
      <el-col :span="10" class="flex_end">
        <el-link
          type="primary"
          :underline="false"
          @click="changDataInfo(),completeShow=false"
          v-show="completeShow&&showChangeInfo"
        >修改信息</el-link>
        <el-button @click="affirmInfo" v-show="!completeShow" size="small" type="primary">确认</el-button>
        <el-button v-show="!completeShow" size="small" @click="cancelInfo">取消</el-button>
      </el-col>
    </el-row>-->
    <el-card class="margin_bottom20 no_margin">
      <el-form label-width="100px">
        <el-form-item label="平台：" :required="!completeShow ? true : false">
          <span v-show="completeShow">{{ getByIdFullData.platform_code | platformChinese }}</span>
          <span v-show="!completeShow">
            <el-select placeholder="请选择" v-model="completeData.platformCode" size="small" clearable>
              <el-option v-for="(item, i) in plateList" :key="i" :label="item.dictName"
                :value="item.dictCode"></el-option>
            </el-select>
          </span>
        </el-form-item>
        <el-form-item label="店铺名称：" :required="!completeShow ? true : false">
          <span v-show="completeShow">{{ getByIdFullData.shopname }}</span>
          <shopNameAuto ref="refShopName" v-show="!completeShow" v-model="completeData.shopname"
            @changeShopName="changeShopName" :platformCode="completeData.platformCode" @selectShopname="selectShopname">
          </shopNameAuto>
          <ShopType :shoptype="completeData.shoptype" v-if="completeData.shoptype"></ShopType>
        </el-form-item>
        <el-form-item label="违规链接：" :required="!completeShow ? true : false">
          <el-link type="primary" :underline="false" :href="getByIdFullData.reporturl" v-show="completeShow"
            target="_blank">{{ getByIdFullData.reporturl }}</el-link>
          <el-input clearable size="small" v-model="completeData.reporturl" v-show="!completeShow" @blur="linkBlur"
            class="input_credit"></el-input>
        </el-form-item>
        <el-form-item label="产品信息：" :required="!completeShow ? true : false">
          <span v-show="completeShow">{{ getByIdFullData.productinfo }}</span>
          <checkProduct v-show="!completeShow" :echoproduct_id="getByIdFullData.productinfoid"
            v-model="completeData.productData" @setproduct="setproduct" ref="refcheckProduct" style="width: 519px;">
          </checkProduct>
        </el-form-item>
        <el-form-item label="图片上传：" v-show="!completeShow">
          <el-upload action="https://192.168.1.229:81/hcm/hcmWorkOrder/headImgUpload/" list-type="picture-card"
            name="file" :http-request="picRequest" multiple :before-upload="beforeAvatarUpload" v-loading="loading"
            element-loading-text="拼命上传中" element-loading-spinner="el-icon-loading">
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div v-if="completeShow && reportPicArray.length" v-for="(item, index) in reportPicArray" :key="index">
            <img :src="item" alt="" class="screenshot_pic">
            <i class="el-icon-error" @click="deletePic(index)"></i>
          </div>
        </el-form-item>

        <el-form-item label="商品名称：">{{ getByIdFullData.itemtitle }}</el-form-item>
        <el-form-item label="SKU信息：">{{ getByIdFullData.skuinfo }}</el-form-item>
        <el-form-item label="违规类型：" v-if="bmcKefuid == '4581'">{{ getByIdFullData.reportviolation }}</el-form-item>

        <el-form-item label="标价：" v-if="bmcKefuid != '4581'">
          <template>
            <el-row>
              <el-col :span="10">{{ getByIdFullData.price }}</el-col>
              <el-col :span="4">建议标价：</el-col>
              <el-col :span="10">{{ getByIdFullData.checkprice }}</el-col>
            </el-row>
          </template>
        </el-form-item>
        <el-form-item label="到手价：" v-if="bmcKefuid != '4581'">
          <el-row>
            <el-col :span="10" v-show="completeShow">{{ getByIdFullData.availableprice }}</el-col>
            <el-col :span="10" v-show="!completeShow">
              <el-input v-model="getByIdFullData.availableprice" placeholder="到手价" size="small"
                style="width: 200px;"></el-input>
            </el-col>
            <el-col :span="4">建议零售价：</el-col>
            <el-col :span="10">{{ getByIdFullData.availablecheckprice }}</el-col>
          </el-row>
        </el-form-item>

        <!-- 2.3字段修改刘杰 -->
        <el-form-item label="举证材料：" v-if="getByIdFullData.rfpic">
          <div class="reportpic_see" @click="toAccessory2(index)"
            v-for="(item, index) in getByIdFullData.rfpic.split(',')" :key="item"
            style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
            {{ item.indexOf('_') > -1 ? item.slice(item.indexOf('_') + 1) : item.slice(item.indexOf('ceshi') + 6) }}
          </div>
        </el-form-item>
        <el-form-item label="补充说明：">
          <template>{{ getByIdFullData.explain }}</template>
        </el-form-item>
        <slot name="other"></slot>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import ShopType from "@/components/shopType";
import shopNameAuto from "views/CreditScore/CreditScoreOutInform/shopNameAuto";
import checkProduct from "components/checkProduct/index";
import { mapActions, mapGetters, mapState } from "vuex";
import { fetchGet, fetchPost } from "@/libs/reqCommon";
import { handleProductUrl, getItemId } from "@/libs";
import axios from "axios";

export default {
  props: {
    // data: {
    //   type: Object,
    //   required: true
    // },
    showChangeInfo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      completeShow: true,
      completeData: {
        reporturl: "",
        platformCode: "",
        productData: [],
        shopid: "",
      },
      shopAll: false, //是否修改过店铺名
      goVerify: false, //判断是进行过验证链接
      shopNameAutoData: {},
      ifVerityLink: true,
      dialogImageUrl: '',
      imageUrl: '',
      uploadPicHtpp: [],
      beformuploadPicHtpp: [],
      loading: false,
      logintype: '',
      bmcKefuid: '',
    };
  },
  computed: {
    ...mapGetters(["plateList", "getByIdFullData"]),
    ...mapState({
      linkVerifyResult: (state) => state.creditScore.linkVerifyResult,
      tbpassword: (state) => state.creditScore.tbpassword,
      infoProductPrice: (state) => state.creditScore.infoProductPrice,
    }),
    reportPicArray() {
      if (this.getByIdFullData && this.getByIdFullData.reportpic) {
        return typeof this.getByIdFullData.reportpic === 'string'
          ? this.getByIdFullData.reportpic.split(',')
          : []; // 如果不是字符串，返回一个空数组以避免错误
      }
      return [];
    }
  },
  components: { ShopType, shopNameAuto, checkProduct },
  created() {
    this.$nextTick(() => {
      this.changInfo();
    });
    this.goVerify = false;
  },
  methods: {
    ...mapActions([
      "reqPlateList",
      "getById",
      "getVerifyReportLink",
      "getInfoByProductIds",
      "getTBPassword",
    ]),
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过20M!');
        return false;
      }
    },
    picRequest(a) {
      //图片上传
      if (this.beformuploadPicHtpp.length > 9) {
        this.$message({ type: 'warning', message: '最多只能上传9张截图' })
        return false
      }
      this.loading = true
      this.beformuploadPicHtpp.push(1)//本地用来判断上传的图片数量
      let that = this;
      var formdata = new FormData()
      formdata.append('file', a.file)
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      const instance = axios.create({
        withCredentials: true
      })
      instance.post("hcm/hcmWorkOrder/headImgUpload", formdata, config).then(function (res) {
        let { data } = res
        that.imgUrl = data.data.data;
        that.uploadPicHtpp.push(that.imgUrl)//http格式的图片地址
        that.loading = false
      });

    },
    cancelInfo() {
      this.completeShow = true;
      this.completeData = {};
      this.completeData.shoptype = this.getByIdFullData.shoptype;
      this.$refs.refShopName.clearData();
    },
    selectShopname(item) {
      if (item) {
        this.$set(this.completeData, "shoptype", item.shoptype);
        this.$set(this.completeData, "shopname", item.shopname);
        this.$set(this.completeData, "shopid", item.shopid);
        if (item.shopname) {
          this.completeData.platformCode = item.platformCode;
        }
      } else {
        this.$set(this.completeData, "shoptype", "");
        this.$set(this.completeData, "shopname", "");
        this.$set(this.completeData, "shopid", "");
      }
      this.$forceUpdate();
    },
    changeShopName() {
      //修改店铺名字
      this.shopAll = true;
    },
    async linkBlur() {
      // if (!/http/.test(this.completeData.reporturl)) {
      //   return false;
      // }
      if (/话/.test(this.completeData.reporturl)) {
        //淘口令
        await this.getTBPassword(this.completeData.reporturl);
        if (this.tbpassword.error == "0") {
          this.completeData.reporturl = this.tbpassword.data.replace(
            "a.m.taobao.com/i",
            "item.taobao.com/item.htm?id="
          );
        } else {
          this.$message.error(this.tbpassword.msg);
          return false;
        }
      }

      this.completeData.reporturl = handleProductUrl(
        this.completeData.reporturl
      );
      if (this.completeData.reporturl === this.getByIdFullData.reporturl) {
        //没有改动链接
        this.ifVerityLink = true;
        return false;
      }
      if (!getItemId(this.completeData.reporturl)) {
        this.ifVerityLink = false;
        return;
      }
      this.ifVerityLink = true;
      await this.getVerifyReportLink([this.completeData.reporturl]); //验证链接
      let result = this.linkVerifyResult[0];
      if (result.reason == 1) {
        //重复提示
        this.$emit("changeRepetitionShow");
        return false;
      }
      this.goVerify = true; //进行过验证链接
      let { platformCode, shopname, productinfoid, shopid, shoptype } = result;
      this.completeData.platformCode = platformCode
        ? platformCode
        : this.completeData.platformCode;
      if (shopname) {
        this.$refs.refShopName.shopname = shopname;
        this.completeData.shopname = shopname;
        this.completeData.shoptype = shoptype;
        this.completeData.shopid = shopid;
      }
      if (productinfoid) {
        this.$refs.refcheckProduct.getProductinfo(productinfoid);
      }
      this.$forceUpdate();
    },
    setproduct(val) {
      console.log(val, 'valvalval')
      if (val.length > 0) {
        this.completeData.productinfo = val[1][1];
        this.completeData.productinfoid = val[0] + "," + val[1][0];
      }
      console.log(this.completeData.productinfo)
      console.log(this.completeData.productinfoid)
      this.changeGetProductInfo();
    },
    async changeGetProductInfo() {
      await this.getInfoByProductIds({
        id: this.completeData.productinfoid,
        platform: this.completeData.platformCode,
      });
    },
    // 产品子组件触发隐藏
    fatClick() {
      this.$refs.refcheckProduct.allQx()
    },
    changDataInfo() {
      this.changInfo();
      this.reqPlateList();
    },
    changInfo() {
      this.logintype = JSON.parse(localStorage.getItem("userData")).logintype; //登录账号类型
      this.bmcKefuid = JSON.parse(localStorage.getItem("userData")).bmcid;
      console.log(this.bmcKefuid, 'this.bmcKefuid')
      //回显
      this.$refs.refShopName.shopname = this.getByIdFullData.shopname;
      this.completeData.platformCode = this.getByIdFullData.platform_code;
      this.completeData.reporturl = this.getByIdFullData.reporturl;
      this.completeData.shoptype = this.getByIdFullData.shoptype;
      this.completeData.shopname = this.getByIdFullData.shopname;
      this.completeData.shopid = this.getByIdFullData.shopid;
      let productinfoid = {
        productinfoid: this.getByIdFullData.productinfoid,
        productinfo: this.getByIdFullData.productinfo,
        type: 1
      }
      if (productinfoid) {
        this.$refs.refcheckProduct.getProductinfo(productinfoid);
      }
    },
    toAccessory(index) {
      let file = this.getByIdFullData.reportpic[index];
      if (/\+/.test(file)) {
        //图片地址带有+号的时候
        let fileFirst = file.slice(0, file.indexOf("_") + 1);
        let fileName = encodeURIComponent(file.slice(file.indexOf("_") + 1));
        fileName = fileName.replace(/\(/g, "%28");
        fileName = fileName.replace(/\)/g, "%29");
        file = fileFirst + fileName;
      }

      if (
        /.png/.test(file) ||
        /.jpg/.test(file) ||
        /.PNG/.test(file) ||
        /.JPG/.test(file)
      ) {
        window.open(file);
      } else {
        window.open(
          "https://view.officeapps.live.com/op/view.aspx?src=" + file
        );
      }
    },
    toAccessory2(index) {
      let file = this.getByIdFullData.rfpic.split(',')[index];
      if (/\+/.test(file)) {
        //图片地址带有+号的时候
        let fileFirst = file.slice(0, file.indexOf("_") + 1);
        let fileName = encodeURIComponent(file.slice(file.indexOf("_") + 1));
        fileName = fileName.replace(/\(/g, "%28");
        fileName = fileName.replace(/\)/g, "%29");
        file = fileFirst + fileName;
      }

      if (
        /.png/.test(file) ||
        /.jpg/.test(file) ||
        /.PNG/.test(file) ||
        /.jpeg/.test(file) ||
        /.JPG/.test(file)
      ) {
        window.open(file);
      } else {
        window.open(
          "https://view.officeapps.live.com/op/view.aspx?src=" + file
        );
      }
    },
    completeInfo() {
      this.completeShow = true;
    },
    async affirmInfo() {
      if (this.completeData.productinfo) {
        this.getByIdFullData.productOneId = this.completeData.productinfoid.split(',')[0];
        this.getByIdFullData.productinfoid = this.completeData.productinfoid.split(',')[1];
        this.getByIdFullData.productinfo = this.completeData.productinfo;
      }
      if (this.getByIdFullData.productOneId) {
        let data = [];
        data.push(this.getByIdFullData.productinfoid);
        data.push(this.getByIdFullData.productinfo);
        this.completeData.productData = [];
        this.completeData.productData.push(this.getByIdFullData.productOneId)
        this.completeData.productData.push(data)
      }

      if (!this.ifVerityLink) {
        this.$message.error("请输入正确的链接");
        return false;
      }
      if (this.getByIdFullData.availableprice >= this.getByIdFullData.availablecheckprice && this.getByIdFullData.creatuser != '匿名举报') {
        this.$message.error("到手价不能大于等于建议零售价");
        return false;
      }

      //补全信息
      let {
        platformCode,
        shopname,
        reporturl,
        productData,
        shopid,
        shoptype,
      } = this.completeData;
      console.log(productData)
      let id = this.getByIdFullData.id; //补全信息的id
      if (!platformCode) {
        this.$message.warning("平台不能为空");
        return false;
      }
      if (!shopname) {
        this.$message.warning("店铺名称不能为空");
        return false;
      }
      if (!reporturl) {
        this.$message.warning("违规链接地址不能为空");
        return false;
      }
      if (productData.length === 0) {
        this.$message.warning("产品信息不能为空");
        return false;
      }
      // let shop = this.shopAll
      //   ? this.shopNameAutoData
      //   : {
      //       shopid: this.getByIdFullData.shopid,
      //       shopname: this.getByIdFullData.shopname,
      //       shoptype: this.getByIdFullData.shoptype
      //     };
      // if (!shop.shoptype) delete shop.shoptype;
      // if (!shop.shopid) delete shop.shopid;
      let otherInfo;
      if (this.goVerify) {
        //验证过链接
        let linkVerifyResult = this.linkVerifyResult[0];
        delete linkVerifyResult.reason;
        otherInfo = linkVerifyResult;
      } else {
        //没有验证过
        let {
          productinfoid,
          productinfo,
          shopname,
          shopid,
          skuinfo,
          itemtitle,
          platform_code,
          availablecheckprice,
          checkprice,
          availableprice,
          price,
          wangwang,
          itemid,
          shoptype,
          itemlink,
        } = this.getByIdFullData;
        otherInfo = {
          productinfoid,
          productinfo,
          // shopname,
          // shopid,
          skuinfo,
          itemtitle,
          availablecheckprice,
          checkprice,
          availableprice,
          price,
          wangwang,
          itemid,
          // shoptype,
          itemlink,
        };
      }

      let data = {
        reporturl,
        id,
        ...otherInfo,
        platformCode,
        productinfo: productData[1][1],
        productinfoid: productData[0] + "," + productData[1][0],
        shopname,
        shopid,
        shoptype,
      };
      if (this.getByIdFullData.rfpic || this.uploadPicHtpp) {
        let allPic = this.getByIdFullData.rfpic + ',' + this.uploadPicHtpp
        data.reportpic = allPic;
      }

      if (this.infoProductPrice) {
        //选择了产品
        data.checkprice = this.linkVerifyResult[0].checkprice;
        data.availablecheckprice = this.linkVerifyResult[0].availablecheckprice;
      }
      if (!data.shopid) delete data.shopid;
      if (!data.shoptype) delete data.shoptype;
      if (this.infoProductPrice) {
        //选择了产品
        data.checkprice = this.linkVerifyResult[0].checkprice;
        data.availablecheckprice = this.linkVerifyResult[0].availablecheckprice;
      }
      fetch({
        url: "hcm/hcmReport/makeUpReport",
        method: "post",
        data,
      }).then((res) => {
        if (res.status == "10000") {
          this.$message.success("成功");
          this.getById(this.getByIdFullData.reportid).then(() => {
            this.$emit("firstTrialInfo");
          });
          this.completeShow = !this.completeShow;
          this.$emit("loadPage");
        }
      });
    },
  },
};
</script>
<style lang="scss">
.commonReport {
  .reportpic_see {
    width: 80%;
    color: #409eff;
    cursor: pointer;
  }

  .shoptype {
    vertical-align: middle;
  }

  .el-select,
  .auto_complete,
  .el-cascader,
  .input_credit {
    width: 80% !important;
  }
}

.hint_dialog {
  z-index: 99999 !important;
}
</style>
